// frontend/src/supabaseClient.js
// Cliente Supabase con modo demo integrado

import { mockSupabaseAuth } from './utils/mockAuth';
import { DEMO_USERS } from './utils/mockData';

// Modo demo activo por defecto para esta versión
const DEMO_MODE = true;

if (DEMO_MODE) {
  console.log('🎮 CommitFlow Demo Mode: ACTIVADO');
}
console.log('📧 Usuarios disponibles: admin@demo.com, jefe@demo.com, colaborador@demo.com');
console.log('🔑 Contraseña: demo123');

// Mock de consultas a la base de datos
const mockFrom = (table) => {
  return {
    select: (fields) => ({
      eq: (field, value) => ({
        single: async () => {
          // Buscar usuario por email
          if (table === 'usuario' && field === 'email') {
            const user = DEMO_USERS[value];
            if (user) {
              return { data: user, error: null };
            }
            return { data: null, error: { message: 'Usuario no encontrado' } };
          }
          return { data: null, error: null };
        },
        // Para consultas que retornan múltiples registros
        then: async (resolve) => {
          resolve({ data: [], error: null });
        }
      }),
      then: async (resolve) => {
        resolve({ data: [], error: null });
      }
    }),
    insert: () => ({
      select: () => ({
        single: async () => ({ data: null, error: null })
      })
    }),
    update: () => ({
      eq: () => ({
        select: () => ({
          single: async () => ({ data: null, error: null })
        })
      })
    }),
    delete: () => ({
      eq: async () => ({ error: null })
    })
  };
};

// Cliente Supabase mock completo
export const supabase = {
  auth: mockSupabaseAuth,
  from: mockFrom,
  storage: {
    from: () => ({
      upload: async () => ({ data: null, error: null }),
      download: async () => ({ data: null, error: null }),
      getPublicUrl: () => ({ data: { publicUrl: '' } })
    })
  },
  // Otros métodos que podrían necesitarse
  rpc: async () => ({ data: null, error: null }),
  channel: () => ({
    on: () => ({ subscribe: () => {} }),
    subscribe: () => {}
  }),
  removeChannel: () => {}
};
